/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum RiskType {
    Person = 'Person',
    ElectronicDevice = 'ElectronicDevice',
    Kraftfahrzeug = 'Kraftfahrzeug',
    Boot = 'Boot',
    Immobilie = 'Immobilie',
    Vera = 'Vera',
    Haushaltseinrichtung = 'Haushaltseinrichtung',
    Betriebseinrichtung = 'Betriebseinrichtung',
    Hotel = 'Hotel',
    Fahrrad = 'Fahrrad'
  }

    export const RiskTypeTranslocoMap: Record<RiskType, string> = {
    [RiskType.Person]: 'riskType.person',
    [RiskType.ElectronicDevice]: 'riskType.electronicDevice',
    [RiskType.Kraftfahrzeug]: 'riskType.kraftfahrzeug',
    [RiskType.Boot]: 'riskType.boot',
    [RiskType.Immobilie]: 'riskType.immobilie',
    [RiskType.Vera]: 'riskType.vera',
    [RiskType.Haushaltseinrichtung]: 'riskType.haushaltseinrichtung',
    [RiskType.Betriebseinrichtung]: 'riskType.betriebseinrichtung',
    [RiskType.Hotel]: 'riskType.hotel',
    [RiskType.Fahrrad]: 'riskType.fahrrad',
    };

    export const RiskTypeOptions = [
  { value: RiskType.Person, labelKey: 'riskType.person' },
  { value: RiskType.ElectronicDevice, labelKey: 'riskType.electronicDevice' },
  { value: RiskType.Kraftfahrzeug, labelKey: 'riskType.kraftfahrzeug' },
  { value: RiskType.Boot, labelKey: 'riskType.boot' },
  { value: RiskType.Immobilie, labelKey: 'riskType.immobilie' },
  { value: RiskType.Vera, labelKey: 'riskType.vera' },
  { value: RiskType.Haushaltseinrichtung, labelKey: 'riskType.haushaltseinrichtung' },
  { value: RiskType.Betriebseinrichtung, labelKey: 'riskType.betriebseinrichtung' },
  { value: RiskType.Hotel, labelKey: 'riskType.hotel' },
  { value: RiskType.Fahrrad, labelKey: 'riskType.fahrrad' },
    ];

